// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"00cb50b6","563":"dfd55926"}[chunkId] + ".chunk.js";
};